import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getWaitingListTimesShop } from '../waitingList/selectors';
import { getShopByRoute } from '../shops/selectors';
import { getShopObject } from '../reservation/selectors';

const mapStateToProps = (state, ownProps) => ({
  shop:
    getShopByRoute(state, ownProps.params.shopRoute) ||
    getShopObject(state) ||
    getWaitingListTimesShop(state),
});

export default compose(
  withRouter,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithShop.js